<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>自动回复</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <el-form ref="form" :model="searchForm" label-width="80px" :inline="true" size="small" class="admin_from">
                <el-form-item label="" :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
                    <el-input v-model="searchForm.key" placeholder="请输入关键词"></el-input>
                </el-form-item>
                <el-form-item label="" :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
                    <el-select v-model="searchForm.type" placeholder="请选择类型" clearable
                               :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
                        <el-option label="文本消息" value="text"></el-option>
                        <el-option label="图文消息" value="image"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="search">查询</el-button>
                    <el-button type="primary" size="small" @click="addRecharge">添加</el-button>
                </el-form-item>
            </el-form>
            <el-table
                    size="small"
                    :data="tableData"
                    border
                    style="width: 100%">

                <el-table-column
                        type="index"
                        label="#">
                </el-table-column>
                <el-table-column
                        prop="key"
                        label="关键词">
                </el-table-column>
                <el-table-column
                        prop="address"
                        label="回复类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type=='text'">文本消息</span>
                        <span v-if="scope.row.type=='image'">图文消息</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="content"
                        label="内容">
                </el-table-column>
                <el-table-column
                        prop="created_at"
                        label="时间">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="150">
                    <template slot-scope="scope">
                        <el-button type="warning" plain size="small" @click="edit(scope.row.id)">修改</el-button>
                        <el-button type="danger" plain size="small" @click="remove(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="el-pagination">
                <el-pagination
                        background
                        @size-change="changeSize"
                        @current-change="changeCurrent"
                        :current-page="params.pagenum"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="params.pagesize"
                        :layout="this.$store.state.paginationLayout"
                        :total="params.totals">
                </el-pagination>
            </div>

        </el-card>
        <!--            新增或编辑-->
        <el-dialog :title="fromTitle" :width="this.$store.state.dialogWidth" :visible.sync="visible">
            <el-row :gutter="20">
                <el-col :span="this.$store.state.elColNum">
                    <el-form ref="form" :label-width="this.$store.state.labelWidth" size="small">
                        <el-form-item label="关键字">
                            <el-input v-model="dataForm.key"></el-input>
                        </el-form-item>
                        <el-form-item label="状态"
                                      :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
                            <el-select v-model="dataForm.type" placeholder="类型"
                                       :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''" style="width: 100%">
                                <el-option label="文本消息" value="text"></el-option>
                                <el-option label="图文消息" value="image"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="内容">
                            <el-input v-model="dataForm.content"></el-input>
                        </el-form-item>
                        <el-form-item label="标题" v-if="dataForm.type=='image'">
                            <el-input v-model="dataForm.title"></el-input>
                        </el-form-item>
                        <el-form-item label="图片" v-if="dataForm.type=='image'">
                            <el-upload
                                    class="avatar-uploader"
                                    action="upDataUrl"
                                    :show-file-list="false"
                                    :http-request="myUpload"
                                    :before-upload="beforeAvatarUpload">
                                <img v-if="dataForm.image" :src="dataForm.image" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="dialogAffirm" size="small">确 定</el-button></span>
        </el-dialog>
    </div>
</template>

<script>
  import {uploadimg} from '../../utils/common'
  import {formatDate} from '../../utils/common'

  export default {

    name: "User",
    data() {
      return {
        params: {
          pagenum: 1,
          pagesize: 10,
          totals: 0
        },
        form: {
          subscribe: '',
          charge: '',
          nickname: '',
        },
        dataForm: {
          key:'',
          type:'',
          content:'',
          title:'',
          image:'',
        },
        tableData: [],
        fromTitle: '',
        visible: false,
        id: '',
        searchForm: {
          key: '',
          type: '',
        }
      }
    },
    created() {
      this.getList()
    },
    methods: {
      getList() {
        let data = {
          page: this.params.pagenum,
          page_size: this.params.pagesize,
          key: this.searchForm.key,
          type: this.searchForm.type,
        };
        this.$axios.get("admin/wechat_reply", data).then((res) => {
          this.params.totals = parseInt(res.data.count);
          this.tableData = res.data.list;
        });
      },
      // 每页显示多少条
      changeSize(val) {
        this.params.pagesize = val;
        this.getList()
      },
      // 当前显示的页数
      changeCurrent(val) {
        this.params.pagenum = val;
        this.getList()
      },
      // 添加用户
      addRecharge() {
        this.fromTitle = '新增';
        this.id = '';
        this.dataForm = {
          key:'',
          type:'',
          content:'',
          title:'',
          image:'',
        };
        this.visible = true;
      },
      // 编辑用户
      edit(id) {
        this.id = id;
        this.fromTitle = '编辑';
        this.$axios.get('admin/wechat_reply/' + id, {}).then((res) => {
          let data = res.data;
          this.dataForm = data;
          this.visible = true;
        });
      },
      // 确认提交添加或编辑用户
      dialogAffirm() {
        if (this.id) {
          this.$axios.put('admin/wechat_reply/' + this.id, this.dataForm).then((res) => {
            this.$message.success('成功');
            this.getList();
            this.visible = false;
          });
        } else {
          // 添加
          this.$axios.post('/admin/wechat_reply', this.dataForm).then((res) => {
            this.$message.success('成功');
            this.getList();
            this.visible = false;
          });
        }
      },
      remove(id) {
        this.$confirm('确定要进行操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.del('admin/wechat_reply/' + id, '').then((res) => {
            this.$message.success('删除成功!');
            this.getList();
          });
        }).catch(() => {

        });
      },
      beforeAvatarUpload(file) {
        var suffix = file.name.substring(file.name.lastIndexOf('.') + 1);
        let arr = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'pdf', 'JPG', 'JPEG', 'PNG', 'GIF', 'BMP', 'PDF']
        if (arr.indexOf(suffix) === -1) {
          this.$message.error('上传图片格式有误');
          return false
        }
      },
      // 上传文件
      myUpload(content) {
        uploadimg(content).then(res => {
          this.dataForm.image = res;
        })
      },
      search() {
        this.params.pagenum = 1;
        this.getList();
      },
    }
  }
</script>

<style scoped>
    .img {
        display: flex;
        align-items: center;
    }

    .img > img {
        margin-right: 10px;
    }
</style>